















import Vue from 'vue'
import { mapGetters } from 'vuex'
import { TenantAppServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import { getFirstMenu, tdTracking } from '@/utils/index'
import { getUserInfo } from '@/utils/auth'
import { getLocalStorage } from "@/utils/storage";

export default Vue.extend({
  name: '',
  data() {
    return {
      menuVisible: false,
      appMap: []
    }
  },
  created() {
    this.getAppList()
  },
  computed: {
    ...mapGetters(['currentApp'])
  },
  methods: {
    onAppClick(app: any) {
      console.log(this.currentApp,'aaa')
      if(this.currentApp === app.key){
        return
      }
      var kv = {}
      kv[getUserInfo().tenant_id] = 1
      var eventId = app.key + '_timeofuse'
      tdTracking(eventId,  kv)
      // 可视化 弹出新页面
      if (app.key === 'vision') {
        const win = window as any
        window.open(win.VISION_URL, '_blank')
        return
      }
      const selectApp = this.appMap.find(item => item.appCode === app.key)
      this.$store.dispatch('app/setAppName', selectApp.appDisplayName)
      this.$store.dispatch('app/setCurrentApp', selectApp.appCode)
      this.$store
        .dispatch('permission/generateRoutes', selectApp.appCode)
        .then(res => {
          this.routerTo(getFirstMenu(res, selectApp.appCode))
        })
    },
    routerTo(link: any) {
      this.$router.push(link)
      this.menuVisible = false
    },
    getAppList() {
      const tenantAppServiceProxy = new TenantAppServiceProxy()
      const pcEdition = 1
      tenantAppServiceProxy.getCurrentTenantGrantAPPList(pcEdition).then(res => {
        this.appMap = res
        if(res){
          if(!getLocalStorage('appName')){
          const name = res.find(item => (item.appCode === 'console')).appDisplayName
          this.$store.dispatch('app/setAppName', name)
          }
        }
      })
    }
  },
  watch: {
    menuVisible(val) {
      if (val) {
        this.getAppList()
      }
    },
    
  }
})
